import { BookletDetails } from "@/@types";
import { BookletDetailsResponse } from "../../booklets/models/BookletDetailsResponse";

export function mapBookletDetails(response: BookletDetailsResponse): BookletDetails {
    return {
        title: response.title,
        description: response.description,
        date: response.date,
        order: response.order,
        image: response.image,
        attachmentType: response.attachment_type,
        url: response.url,
        slug: response.slug,
        category: response.category
    }
}